export default __webpack_public_path__ + "static/lehoangson-802382e55c5aea78ae8b22ab542847d1.jpg";